<div>
    <app-searchbarpopupexact (onClicked)="click()" *ngFor="let itemx of ExactResults | slice:0:3;" [Artikel]="itemx"></app-searchbarpopupexact>
    <hr class="np" [hidden]="ishidden">
    <app-searchbarpopupitem (onClicked)="click()" *ngFor="let item of FoundResults | slice:0:3;" [Artikel]="item"></app-searchbarpopupitem>
    <div class="l1more" [hidden]="FoundResults.length<3" (click)="onMeer()">{{translate('Bekijk meer')}}...</div>
    <div [hidden]="isnoresult()">&nbsp; {{translate('Dit artikel zit niet in ons assortiment of pas de omschrijving aan')}} ...</div>
</div>